<template>
  <div v-if="!d_frontendLoading" style="min-height: 750px;">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        <template v-if="StoreFrontendSettings.data.shop_text">
          {{ StoreFrontendSettings.data.shop_text[StoreLang] }}
        </template>
        <template v-else>
          {{ StoreLangTranslation.data['shop'][StoreLang] }}
        </template>
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <div class="wrapper">
      <div class="animated fadeIn">
          <template v-if="d_loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template>
            <template v-for="(shop_id, shop_index) in d_productList.param_order">
              <b-row style="margin-bottom: 10px; font-size: 14px;">
                <b-col sm="12" lg="2"></b-col>
                <b-col sm="12" lg="8">
                  <b-form-input v-model="d_searchProduct" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
                </b-col>
                <b-col sm="12" lg="2"></b-col>
              </b-row>
              <b-row style="margin-bottom: 10px; font-size: 14px;">
                <b-col sm="12" lg="2"></b-col>
                <b-col sm="12" lg="8">
                  <!-- <b-row style="margin: 0px; background-color: #93ffe4; padding: 5px;"> -->
                  <b-row class="top-info-card" style="margin: 0px; padding: 5px;">
                    <b-col sm="12" lg="4">
                      <template v-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['2'] && d_productList.parameters[shop_id].data.data['0']['2']['lang'] && d_productList.parameters[shop_id].data.data['0']['2']['lang'][StoreLang]">
                        <img :src="d_productList.parameters[shop_id].data.data['0']['2']['lang'][StoreLang]" style="width: 30px; margin-right: 5px;">
                      </template>
                      <template v-else-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['2'] && d_productList.parameters[shop_id].data.data['0']['2']['val']">
                        <img :src="d_productList.parameters[shop_id].data.data['0']['2']['val']" style="width: 30px; margin-right: 5px;">
                      </template>

                      <template v-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['1'] && d_productList.parameters[shop_id].data.data['0']['1']['lang'] && d_productList.parameters[shop_id].data.data['0']['1']['lang'][StoreLang]">
                        <strong :title="d_productList.parameters[shop_id].data.data['0']['1']['lang'][StoreLang]">{{ d_productList.parameters[shop_id].data.data['0']['1']['lang'][StoreLang].length > 30 ? d_productList.parameters[shop_id].data.data['0']['1']['lang'][StoreLang].substring(0,30) + '...' : d_productList.parameters[shop_id].data.data['0']['1']['lang'][StoreLang] }}</strong>
                      </template>
                      <template v-else-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['1'] && d_productList.parameters[shop_id].data.data['0']['1']['val']">
                        <strong :title="d_productList.parameters[shop_id].data.data['0']['1']['val']">{{ d_productList.parameters[shop_id].data.data['0']['1']['val'].length > 30 ? d_productList.parameters[shop_id].data.data['0']['1']['val'].substring(0,30) + '...' : d_productList.parameters[shop_id].data.data['0']['1']['val'] }}</strong>
                      </template>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <i class="fa fa-envelope" style="margin-right: 5px;"></i>
                        <template v-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['29'] && d_productList.parameters[shop_id].data.data['0']['29']['lang'] && d_productList.parameters[shop_id].data.data['0']['29']['lang'][StoreLang]">
                          <strong>{{ d_productList.parameters[shop_id].data.data['0']['29']['lang'][StoreLang] }}</strong>
                        </template>
                        <template v-else-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['29'] && d_productList.parameters[shop_id].data.data['0']['29']['val']">
                          <strong>{{ d_productList.parameters[shop_id].data.data['0']['29']['val'] }}</strong>
                        </template>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <i class="fa fa-mobile-phone" style="margin-right: 5px;"></i>
                      <template v-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['30'] && d_productList.parameters[shop_id].data.data['0']['30']['lang'] && d_productList.parameters[shop_id].data.data['0']['30']['lang'][StoreLang]">
                        <strong>{{ d_productList.parameters[shop_id].data.data['0']['30']['lang'][StoreLang] }}</strong>
                      </template>
                      <template v-else-if="d_productList.parameters[shop_id].data.data && d_productList.parameters[shop_id].data.data['0'] && d_productList.parameters[shop_id].data.data['0']['30'] && d_productList.parameters[shop_id].data.data['0']['30']['val']">
                        <strong>{{ d_productList.parameters[shop_id].data.data['0']['30']['val'] }}</strong>
                      </template>
                    </b-col>
                    <b-col sm="12" lg="1"></b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" lg="2"></b-col>
              </b-row>

              <template v-if="d_frontendData['shop_view'] && d_frontendData['shop_view'] == '2' && d_randomThreeBundle[shop_id].length" >
                <b-row style="font-size: 14px;">
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="8">
                    <b-row style="text-align: left; font-weight: 900; border-radius: 10px 10px; background-color: #adfcbd; margin: 3px; padding: 10px;">
                      <b-col cols="12">
                        <i class="fa fa-angle-double-right"></i>
                        <strong> {{ StoreLangTranslation.data['featured'][StoreLang].toUpperCase() }}</strong>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                </b-row>  
                
                <b-row style="font-size: 14px;">
                  <b-col sm="12" lg="2"></b-col>
                  <b-col sm="12" lg="8">
                    <b-row style="margin-bottom: 20px;">
                      <template v-for="(random_bundle, random_bundle_index) in d_randomThreeBundle[shop_id]">
                        <b-col sm="12" lg="4" style="padding: 10px;">
                          <b-card class="product-card bundle-card-card" @click="f_goToBundleDetails(d_productList.parameters[shop_id].data.client_id, random_bundle.client_id)" style="padding: 22px 26px; border-radius: 14px; border: 1px solid #dbe3ef; box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06); background: #f8fafc; cursor: pointer; transition: all 0.25s ease;">
                            <!-- Başlık ve uploader alanı -->
                            <div class="bundle-left" style="margin-bottom: 14px;">
                              <h3 style="margin: 0; font-size: 18px; font-weight: 600; color: #0f172a; line-height: 1.4;">
                                {{ random_bundle.data.data.data['0']['1']['lang'][StoreLang] }}
                              </h3>
                              <p class="uploaded" v-if="random_bundle.client_id in d_bundleCreatorList" style="margin: 6px 0 0; font-size: 14px; color: #64748b;">
                                <!-- {{ StoreLangTranslation.data['uploaded_by'][StoreLang] }} -->
                                <!-- {{ d_bundleCreatorList[random_bundle.client_id]['bundle_author_firstname_and_lastname_list'] }} -->
                                <template v-if="random_bundle.id && d_productList.parameters[shop_id].parameters[random_bundle.id] && d_productList.parameters[shop_id].parameters[random_bundle.id].data && d_productList.parameters[shop_id].parameters[random_bundle.id].data.data['0']['57'] && d_productList.parameters[shop_id].parameters[random_bundle.id].data.data['0']['57']['list'] && d_productList.parameters[shop_id].parameters[random_bundle.id].data.data['0']['57']['list'].length > 0">
                                    <template v-for="(author_item, author_index) in d_productList.parameters[shop_id].parameters[random_bundle.id].data.data['0']['57']['list']">
                                      <template v-if="author_item['60'] && author_item['60']['val']">
                                        {{ author_item['60']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['58'] && author_item['58']['val']">
                                        {{ author_item['58']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['59'] && author_item['59']['val']">
                                        {{ author_item['59']['val'] }}
                                      </template>
                                      <template v-if="author_index + 1 != d_productList.parameters[shop_id].parameters[random_bundle.id].data.data['0']['57']['list'].length">
                                        {{ ', ' }}
                                      </template>
                                    </template>
                                  </template>
                              </p>
                            </div>
                              <!-- <div v-if="random_bundle.data.data.data['0']['56'] && random_bundle.data.data.data['0']['56']['val']['value'] == '1'" class="bundle-right-dataset" style="margin-bottom: 10px;">

                              <span>
                                [{{StoreLangTranslation.data['dataset_size'][StoreLang]}}:
                                {{random_bundle.data.data.data['0']['36']['val']}}x{{random_bundle.data.data.data['0']['37']['val']}}]
                              </span>
                              </div> -->

                            <!-- AVAILABLE SOON -->
                            <div v-if="random_bundle.data.data.data['0']['12'] && random_bundle.data.data.data['0']['12']['val']['value'] === '1'" class="bundle-price" style="background: #fff3cd; color: #856404; border-radius: 10px; font-size: 16px; font-weight: 600; padding: 8px 14px; box-shadow: none; text-align: center; margin-bottom: 14px;">
                              {{ StoreLangTranslation.data['available_soon'][StoreLang] }}
                            </div>
                            <!-- PRICE -->
                            <div v-else-if="random_bundle.data.data.data['0']['13'] && random_bundle.data.data.data['0']['13']['val']['value'] === '1'" class="bundle-price" style="font-size: 16px; font-weight: 700; color: white; background: linear-gradient(to bottom right, #1FA2FF, #12D8FA); padding: 10px 18px; border-radius: 12px; box-shadow: 0 2px 6px rgba(3,105,161,0.25); text-align: center; margin-bottom: 14px;">
                              {{ f_calculateBundleTotalPrice(random_bundle.data) }}
                            </div>
                            <!-- Dataset tipi ise dataset özellikleri listeleme -->
                            <template v-if="random_bundle.data.data.data['0']['56'] && random_bundle.data.data.data['0']['56']['val'] && random_bundle.data.data.data['0']['56']['val']['value'] && random_bundle.data.data.data['0']['56']['val']['value'] == '1'">
                              <b-row v-if="random_bundle.data.data.data['0']['36'] && random_bundle.data.data.data['0']['36']['val']" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                  {{ d_userShopBundleWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}:
                                  <small> {{ random_bundle.data.data.data['0']['36']['val'] }} </small>
                                </b-col>
                              </b-row>
                              <b-row v-if="random_bundle.data.data.data['0']['37'] && random_bundle.data.data.data['0']['37']['val']" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                  {{ d_userShopBundleWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}:
                                  <small> {{ random_bundle.data.data.data['0']['37']['val'] }} </small>
                                </b-col>
                              </b-row>
                              <!-- <b-row v-if="random_bundle.data.data.data['0']['38'] && random_bundle.data.data.data['0']['38']['val']" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                  {{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}:
                                  <small :title="random_bundle.data.data.data['0']['38']['val']"> {{ f_limitText(random_bundle.data.data.data['0']['38']['val'], 100) }} </small>
                                </b-col>
                              </b-row> -->
                              <!-- <b-row v-if="random_bundle.data.data.data['0']['39'] && random_bundle.data.data.data['0']['39']['val']" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                  {{ d_userShopBundleWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}:
                                  <small :title="random_bundle.data.data.data['0']['39']['val']"> {{ f_limitText(random_bundle.data.data.data['0']['39']['val'], 100) }} </small>
                                </b-col>
                              </b-row> -->
                              <b-row v-if="random_bundle.data.data.data['0']['35'] && random_bundle.data.data.data['0']['35']['val'] && random_bundle.data.data.data['0']['35']['val']['value']" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                  {{ d_userShopBundleWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}:
                                  <small> {{ d_userShopBundleWdm['0']['parameters']['35'].options[random_bundle.data.data.data['0']['35']['val']['value']].translation[StoreLang] }} </small>
                                </b-col>
                              </b-row>
                            </template>

                            <!-- Özellik listeleme (aynen korunuyor) -->
                            <template v-else-if="random_bundle.data.data.data['0']['2'] && random_bundle.data.data.data['0']['2'].list && random_bundle.data.data.data['0']['2'].list.length > 0">
                              <template v-for="(feature_item, feature_item_index) in random_bundle.data.data.data['0']['2']['list']">
                                <b-row v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value === '1'" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                  <b-col sm="12" md="12">
                                    <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                    <small>{{ feature_item['3']['lang'][StoreLang] }}</small>
                                  </b-col>
                                </b-row>
                              </template>
                            </template>
                          </b-card>
                        </b-col>
                      </template>
                    </b-row>



                  </b-col>
                  <b-col sm="12" lg="2"></b-col>
                </b-row> 

              </template>
              <template v-for="(bundle_group_id, bundle_group_index) in d_productList.parameters[shop_id].groups.param_order">

                <template v-if="f_viewBundleGroup(shop_id, d_productList.parameters[shop_id].groups.parameters[bundle_group_id]['id_list'])">
                <!-- <template> -->
                  <!-- {{ d_productList.parameters[shop_id].groups.parameters[bundle_group_id]['id_list'] }} -->
                  <!-- {{ d_productList.parameters[shop_id].parameters[d_productList.parameters[shop_id].groups.parameters[bundle_group_id]['id_list'][0]].data.data['0']['10']['lang'][StoreLang] }} -->
                  <b-row style="font-size: 14px;">
                    <b-col sm="12" lg="2"></b-col>
                    <b-col sm="12" lg="8">
                      <b-row style="text-align: left; font-weight: 900; border-radius: 10px 10px; background-color: #adfcbd; margin: 3px; padding: 10px;">
                        <b-col cols="12">
                          <i class="fa fa-angle-double-right"></i>
                          <strong> {{ d_productList.parameters[shop_id].groups.parameters[bundle_group_id]['name'][StoreLang].toLocaleUpperCase() }}</strong>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col sm="12" lg="2"></b-col>
                  </b-row>
                  <b-row style="font-size: 14px;">
                    <b-col sm="12" lg="2"></b-col>
                    <b-col sm="12" lg="8" v-if="(d_frontendData['shop_view'] && d_frontendData['shop_view'] == '2') || StoreDevice.isMobile == '1'">
                      <b-row style="margin-bottom: 20px;">
                        <template v-for="(bundle_id, i) in d_productList.parameters[shop_id].groups.parameters[bundle_group_id].id_list">
                          <b-col v-if="f_viewBundle(shop_id, bundle_id)" sm="12" lg="12" style="padding: 5px 0;">
                            <div class="bundle-card-list" @click="f_goToBundleDetails(d_productList.parameters[shop_id].data.client_id, d_productList.parameters[shop_id].parameters[bundle_id].data.client_id)">

                              <div class="bundle-left">
                                <h3>{{ i + 1 }}) {{ d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['1']['lang'][StoreLang] }}</h3>
                                <p class="uploaded" v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.client_id in d_bundleCreatorList">
                                  <!-- {{ StoreLangTranslation.data['uploaded_by'][StoreLang] }} -->
                                  <!-- {{ d_bundleCreatorList[d_productList.parameters[shop_id].parameters[bundle_id].data.client_id]['bundle_author_firstname_and_lastname_list'] }} -->

                                  <template v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'].length > 0">
                                    <template v-for="(author_item, author_index) in d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list']">
                                      <template v-if="author_item['60'] && author_item['58']['val']">
                                        {{ author_item['60']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['58'] && author_item['58']['val']">
                                        {{ author_item['58']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['59'] && author_item['59']['val']">
                                        {{ author_item['59']['val'] }}
                                      </template>
                                      <template v-if="author_index + 1 != d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'].length">
                                        {{ ', ' }}
                                      </template>
                                    </template>
                                  </template>
                                </p>
                              </div>
                              <div class="bundle-right">
                                <div v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['56'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['56']['val']['value'] == '1'" class="bundle-right-dataset">
                                
                                  {{StoreLangTranslation.data['dataset_size'][StoreLang]}}:
                                  {{d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['36']['val']}}x{{d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['37']['val']}}
                                
                                </div>
                                <!-- AVAILABLE SOON -->
                                <div v-if=" d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['12'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['12']['val']['value'] === '1'" class="bundle-price" style="background: #fff3cd; color: #856404; border-radius: 10px; font-size: 16px; font-weight: 600; padding: 8px 14px; box-shadow: none;"
                                >
                                  {{ StoreLangTranslation.data['available_soon'][StoreLang] }}
                                </div>
                                <!-- PRICE -->
                                <div v-else-if=" d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['13'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['13']['val']['value'] === '1'" class="bundle-price">
                                  {{ f_calculateBundleTotalPrice(d_productList.parameters[shop_id].parameters[bundle_id]) }}
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </template>
                      </b-row>
                      <hr>
                    </b-col>
                    <b-col sm="12" lg="8" v-else>
                      <b-row style="margin-bottom: 20px;">

                        <template v-for="(bundle_id, bundle_id_index) in d_productList.parameters[shop_id].groups.parameters[bundle_group_id].id_list">
                          <b-col v-if="f_viewBundle(shop_id, bundle_id)" sm="12" lg="4" style="padding: 10px;">
                            <b-card class="product-card bundle-card-card" @click="f_goToBundleDetails(d_productList.parameters[shop_id].data.client_id, d_productList.parameters[shop_id].parameters[bundle_id].data.client_id)" style="padding: 22px 26px; border-radius: 14px; border: 1px solid #dbe3ef; box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06); background: #f8fafc; cursor: pointer; transition: all 0.25s ease;">
                              <!-- Başlık ve uploader alanı -->
                              <div class="bundle-left" style="margin-bottom: 14px;">
                                <h3 style="margin: 0; font-size: 18px; font-weight: 600; color: #0f172a; line-height: 1.4;">
                                  {{ d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['1']['lang'][StoreLang] }}
                                </h3>
                                <p class="uploaded" v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.client_id in d_bundleCreatorList" style="margin: 6px 0 0; font-size: 14px; color: #64748b;">
                                  <!-- {{ StoreLangTranslation.data['uploaded_by'][StoreLang] }} -->
                                  <!-- {{ d_bundleCreatorList[d_productList.parameters[shop_id].parameters[bundle_id].data.client_id]['bundle_author_firstname_and_lastname_list'] }} -->
                                  <!-- {{ d_productList.parameters[shop_id].parameters[bundle_id].data }} -->
                                  <template v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'].length > 0">
                                    <template v-for="(author_item, author_index) in d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list']">
                                      <template v-if="author_item['60'] && author_item['60']['val']">
                                        {{ author_item['60']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['58'] && author_item['58']['val']">
                                        {{ author_item['58']['val'] }}{{ ' ' }}
                                      </template>
                                      <template v-if="author_item['59'] && author_item['59']['val']">
                                        {{ author_item['59']['val'] }}
                                      </template>
                                      <template v-if="author_index + 1 != d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['57']['list'].length">
                                        {{ ', ' }}
                                      </template>
                                    </template>
                                  </template>
                                </p>
                              </div>
                              <!-- AVAILABLE SOON -->
                              <div v-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['12'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['12']['val']['value'] === '1'" class="bundle-price" style="background: #fff3cd; color: #856404; border-radius: 10px; font-size: 16px; font-weight: 600; padding: 8px 14px; box-shadow: none; text-align: center; margin-bottom: 14px;">
                                {{ StoreLangTranslation.data['available_soon'][StoreLang] }}
                              </div>
                              <!-- PRICE -->
                              <div v-else-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['13'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['13']['val']['value'] === '1'" class="bundle-price" style="font-size: 16px; font-weight: 700; color: white; background: linear-gradient(to bottom right, #1FA2FF, #12D8FA); padding: 10px 18px; border-radius: 12px; box-shadow: 0 2px 6px rgba(3,105,161,0.25); text-align: center; margin-bottom: 14px;">
                                {{ f_calculateBundleTotalPrice(d_productList.parameters[shop_id].parameters[bundle_id]) }}
                              </div>
                              <!-- Ürün listelemeleri (aynen bırakıldı, sadece görünüm korunuyor) -->
                              <template v-if="d_frontendData['shop_view'] && d_frontendData['shop_view'] == '0' && d_productList.parameters[shop_id].parameters[bundle_id].param_order.length > 0">
                                <template v-for="(product_id, product_id_index) in d_productList.parameters[shop_id].parameters[bundle_id].param_order">
                                  <b-row v-if="d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0'] && d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0']['29'] && d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0']['29']['val'] && d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0']['29']['val']['value'] === '1'" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0;">
                                    <b-col sm="12" md="12" style="text-align: left;">
                                      <i style="background: #e2f3ff; border-radius: 8px; padding: 3px 8px; margin-right: 6px;">*</i>
                                      <strong style="font-size: 14px;">
                                        {{ d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0']['9']['lang'][StoreLang] }}
                                      </strong>
                                      <small style="font-size: 14px;">
                                        {{ d_productList.parameters[shop_id].parameters[bundle_id].parameters[product_id].data.data['0']['10']['lang'][StoreLang] }}
                                      </small>
                                    </b-col>
                                  </b-row>
                                </template>
                              </template>
                              <!-- Özellik listeleme (aynen korunuyor) -->
                              <template v-else-if="d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['2'] && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['2'].list && d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['2'].list.length > 0">
                                <template v-for="(feature_item, feature_item_index) in d_productList.parameters[shop_id].parameters[bundle_id].data.data['0']['2']['list']">
                                  <b-row v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value === '1'" style="margin: 0; border-bottom: 1px solid #eaeaea; padding: 6px 0; text-align: left;">
                                    <b-col sm="12" md="12">
                                      <i class="fa fa-asterisk" style="font-size: 10px; margin-right: 4px;"></i>
                                      <small>{{ feature_item['3']['lang'][StoreLang] }}</small>
                                    </b-col>
                                  </b-row>
                                </template>
                              </template>
                            </b-card>
                          </b-col>
                        </template>
                      </b-row>
                      <hr>
                    </b-col>
                    <b-col sm="12" lg="2"></b-col>
                  </b-row>
                </template>
              </template>
              <b-row style="font-size: 14px;">
                <b-col sm="12" lg="2"></b-col>
                <b-col sm="12" lg="8">
                  <template v-if="d_productList.parameters[shop_id].no_groups && d_productList.parameters[shop_id].no_groups.id_list && d_productList.parameters[shop_id].no_groups.id_list.length > 0">
                    <b-row style="margin-bottom: 20px;">
                      <b-col v-for="(no_group_id, no_group_id_index) in d_productList.parameters[shop_id].no_groups.id_list" cols="12" sm="12" lg="4">
                        <b-card footer-class="px-3 py-2" style="height: 100%;">
                          <b-row style="margin: 5px;">
                            <b-col sm="12" md="12">
                              <strong> {{ d_productList.parameters[shop_id].parameters[no_group_id].data.data['0']['1']['lang'][StoreLang] }} </strong>

                              <p>{{ f_calculateBundleTotalPrice(d_productList.parameters[shop_id].parameters[no_group_id]) }}</p>
                            </b-col>                             
                          </b-row>
                          <div slot="footer">
                            <b-link class="font-weight-bold font-xs btn-block text-muted" href="javascript:;" @click="f_goToBundleDetails(d_productList.parameters[shop_id].parameters[no_group_id].data.data['0']['18']['val'], f_getBundleClientId(shop_id, no_group_id))">Detaylar <i class="fa fa-angle-right float-right font-lg"></i></b-link>     
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
                <b-col sm="12" lg="2"></b-col>
              </b-row>
            </template>
          </template>
      </div>
    </div>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {  default as PageInfo} from '@/components/widgets/PageInfo';
import { mapGetters } from 'vuex';
export default {
  name: 'shop',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreCurrencyType: 'StoreCurrencyType',
    StoreExchangeData:'StoreExchangeData'
  }),
  components: {
    PageInfo,
  },
  props: {},
  data () {
    return {
      d_exchange_data: {},
      d_loading: false,
      d_currencyType: '0', // 0 tl, 1 dollar
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_productList: '',
      d_frontendLoading: false,
      d_frontendData: {
        'application_name': {},
        'are_shop_pages_active': '',
        'login_background_color': '',
        'login_buttons_background_color': '',
        'login_card_in_background_color': '',
        'login_card_in_shadow_color': '',
        'login_card_out_background_color': '',
        'login_card_out_shadow_color': '',
        'login_function': '',
        'register_function': '',
        'login_function_external': '',
        'login_inputs_border_color': '',
        'login_loading_background_color': '',
        'login_slogan_text': {},
        'mail_api_send_mail_uri': '',
        'mail_api_token_password': '',
        'mail_api_token_uri': '',
        'mail_api_token_username': '',
        'menu_background_color': '',
        'menu_border_bottom_color': '',
        'menu_box_shadow_color': '',
        'menu_child_item_background_color': '',
        'menu_child_item_border_bottom_color': '',
        'menu_child_item_text_color': '',
        'navbar_application_name_color': '',
        'menu_parent_item_background_color': '',
        'menu_parent_item_border_bottom_color': '',
        'menu_parent_item_text_color': '',
        'menu_top_caption': {},
        'menu_type': '',
        'meta': '',
        'meta_value': '',
        'navbar_application_name_shadow_color': '',
        'navbar_background_color': '',
        'password_reset_mail_approve_frontend_uri_and_route': {},
        'password_reset_mail_approve_link_text': {},
        'password_reset_mail_approve_subject': {},
        'privacy_policy_link': {},
        'register_mail_approve_frontend_uri_and_route': {},
        'register_mail_approve_link_text': {},
        'register_mail_approve_mail_from': '',
        'register_mail_approve_mail_from_password': '',
        'register_mail_approve_subject': {},
        'mail_privacy_notice_text': {},
        'mail_smtp_address': '',
        'mail_smtp_username': '',
        'mail_smtp_password': '',
        'status': '',
        'terms_of_service_link': {},
        'wanalyzer_api_password': '',
        'wanalyzer_api_url': '',
        'wanalyzer_api_username': '',
        'wanalyzer_frontend_url': '',
        'wmanager_uri': '',
        'worganization_api_password': '',
        'worganization_api_url': '',
        'worganization_api_username': '',
        'worganization_frontend_url': '',
        'worganization_organizasyon_id_values': '',
        'worganization_token': '',
        'waccount_external_key': '',
        'waccount_url': '',
        'waccount_username': '',
        'waccount_password': '',
        'waccount_system_product_id': '',
        'worganization_user_id': '',
        'application_frontend_uri': '',
        'application_backend_uri': '',
        'support_details_subject': {},
        'support_mail_from': '',
        'support_mail_from_password': '',
        'support_details_link_text': {},
        'support_details_frontend_uri_and_route': {},
        'page_area_text_color': {},
        'footer_text_color': {},
        'footer_background_color': {},
        'navbar_text_color': {},
        'facebook_link': {},
        'twitter_link': {},
        'instagram_link': {},
        'linkedin_link': {},
        'login_background_image': {},
        'footer_date': '',
        'navbar_flowing_text': {},
        'footer_date': '',
        'footer_text_padding': '',
        'footer_text_size': '',
        'footer_text_weight': '',
        'general_font_select': '',
        'general_font_size': '',
        'general_font_style': '',
        'general_font_weight': '',
        'general_text_color': '',
        'language_options': [],
        'market_visiblity_type': '',
        'navbar_font_size': '',
        'navbar_text_weight': '',
        'page_favicon': '',
        'default_language': '',
        'language_change_button_visibility': '',
        'google_analytics_id': '',
        'login_button_name': {},
        'language_change_button_type': '',
        'domain': '',
        'package_groups_to_show_in_shop': {},
        'shop_view': '',
      },
      d_searchProduct: '',
      d_bundleCreatorList: {},
      d_randomThreeBundle: {},
      d_userShopBundleWdm: '',
    };
  },
  created: function () {
    // this.d_user = JSON.parse(localStorage.getItem('user'));
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    this.f_getFrontendSettings();
    // this.f_bundleAndProductListActive();
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
  },
  methods: {
    f_getBundleClientId(shopId, bundleKey) {
      return this.d_productList.parameters[shopId].parameters[bundleKey].data.client_id;
    },/*
    f_getExchangeCurData(){
      ServiceFunctions.get_exchange_cur_data().then(resp => {
        if (resp.data.status_code.slice(-3)==='000') {
          this.d_exchange_data = resp.data.USD_TRY_Selling;
        }
      })
      .catch(error => {
        console.log("API error:", error)
        })
    },*/
    f_limitText: function(text, limit) {
      if (!text) return "";
      if (text.length <= limit) return text;
      return text.substring(0, limit) + "...";
    },
    f_getFrontendSettings: function () {
      let query = 'ss=1';
      let data = {};
      this.d_frontendLoading = true;
      ServiceFunctions.frontend_get(query, data)
        .then(resp => {
          this.d_frontendLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_frontendData = resp.data.frontend;
            this.$store.commit('MutationFrontendSettings', { 'status': 1, 'data': this.d_frontendData });
            if (this.d_frontendData.are_shop_pages_active === '1') {
              this.f_bundleAndProductListActive();
            } else {
              this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_viewBundleGroup: function (shop_id, id_list) {
      let view_eligible = true;
      try {
        for (let i = 0; i < id_list.length; i++) {
          let bundle_name = this.d_productList.parameters[shop_id].parameters[id_list[i]].data.data['0']['1']['lang'];
          let bundle_group = this.d_productList.parameters[shop_id].parameters[id_list[i]].data.data['0']['10']['lang'];
          if (this.d_searchProduct) {
            let include = false;
            for (let lang in bundle_name) {
              if (bundle_name[lang].toLocaleLowerCase().indexOf(this.d_searchProduct.toLocaleLowerCase()) !== -1) {
                include = true;
              }
            }
            if (!include) {
              for (let lang in bundle_group) {
                if (bundle_group[lang].toLocaleLowerCase().indexOf(this.d_searchProduct.toLocaleLowerCase()) !== -1) {
                  include = true;
                }
              }
            }
            if (include) {
              view_eligible = true;
              break;
            } else {
              view_eligible = false;
            }
          }
        }
      } catch(err) {
        console.log(err)
      }
      return view_eligible;
    },
    f_viewBundle: function (shop_id, bundle_id) {
      // normalde default olarak bundle görünebilir şekilde çalışıyor. Ama in_store_visibility görünmesin şeklinde tanımlandıysa gösterilmiyor.
      let view_eligible = true;
      try {
        let bundle_data = this.d_productList.parameters[shop_id].parameters[bundle_id].data;
        let bundle_name = bundle_data.data['0']['1']['lang'];
        let bundle_group = bundle_data.data['0']['10']['lang'];
        // console.log(bundle_data)
        let in_store_visibility = bundle_data['data']['0']['20']['val']['value'];
        if (in_store_visibility === '0') {
          view_eligible = false;
        } else if (this.d_searchProduct) {
          let include = false;
          for (let lang in bundle_name) {
            if (bundle_name[lang].toLocaleLowerCase().indexOf(this.d_searchProduct.toLocaleLowerCase()) !== -1) {
              include = true;
            }
          }
          if (!include) {
            for (let lang in bundle_group) {
              if (bundle_group[lang].toLocaleLowerCase().indexOf(this.d_searchProduct.toLocaleLowerCase()) !== -1) {
                include = true;
              }
            }
          }
          if (!include) {
            view_eligible = false;
          }
        }
      } catch(err) {}
      return view_eligible;
    },
    f_calculateBundleTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_id in bundle_products.parameters) {
        tl_price = null;
        non_tl_price = null;
        try {
          for (let currency_amount_index in bundle_products.parameters[product_id].data.data['0']['25'].list) {
            let currency_amount_item = bundle_products.parameters[product_id].data.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products.parameters[product_id].data.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];//Buradan ürünün para birimi geliyor. 0,1..
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];//Buradan sayfanın par birimi geliyor 0,1..
            if (page_cur_type != null){//Kur dosyamızda örneğin sayfa TL, bizde TL varmı
              if (exchange_cur_type != null){//Ürün para birimi örneğin USD, bizde USD varmı
                if(this.d_exchange_data[page_cur_type] != null){//Sayfaya göre Kur değerlerimiz varmı? sayfa TL, TL için kur değerleri varmı
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                  //Buradada exchange_data['sayfa_para_birimi('TL')'][ürün_para_birimi('Dolar')] = 43,...
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price * exchange_amount);
                  }
                }
                else{//Kur değeri Güncel
    
                  if(this.StoreCurrencyType.value ==='0'){
                    //Sayfa para birimi tl ise
                    if(tl_price !== null){
                      total_amount += tl_price;
                    }
                    else{
                      total_amount += non_tl_price * exchange_amount;
                    }
                  }
                  else{
                    //sayfa para birimide dolar ise
                    if(non_tl_price !== null){
                      total_amount += non_tl_price;
                    }
                    else{
                      total_amount += tl_price * exchange_amount;
                    }
                  }
                }  
            } catch(err) {}
          
        } catch(err) {console.log(err);}
      }
      return total_amount.toFixed(2) + ' ' + currency_text; 
    },
    f_goToBundleDetails: function (user_shop_client_id, user_shop_bundle_client_id) {
      // this.$router.push({ path: ClsRoute.f_getRoutePath('product_details', this.StoreLang), query: { 'user_shop_client_id': user_shop_client_id, 'user_shop_bundle_client_id': user_shop_bundle_client_id } });
      const routePath = ClsRoute.f_getRoutePath('product_details', this.StoreLang);
      const queryParams = new URLSearchParams({
        user_shop_client_id: user_shop_client_id,
        user_shop_bundle_client_id: user_shop_bundle_client_id
      }).toString();

      const fullUrl = `${routePath}?${queryParams}`;
      window.open(fullUrl, '_blank');
    },
    f_bundleAndProductListActive: function () {
      this.d_loading = true;
      let query = '';
      let data = {};
      ServiceFunctions.bundle_and_product_list_active(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              //console.log(resp.data);
              this.d_productList = resp.data.list;
              this.d_bundleCreatorList = resp.data.bundle_creator_list;
              this.d_exchange_data = resp.data.exchange_data;
              if (this.d_frontendData['shop_view'] && this.d_frontendData['shop_view'] == '2') {
                for (let shop_index in this.d_productList.parameters) {
                  this.d_randomThreeBundle[shop_index] = [];
                  this.f_getRandomThreeBundle(shop_index);
                }
              }
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });

    },
    'f_getRandomThreeBundle': function (shop_index) {
      let bundleIdList = [];
      for (let i of this.d_productList.parameters[shop_index].groups.param_order) {
        bundleIdList.push(...this.d_productList.parameters[shop_index].groups.parameters[i].id_list);
      }

      const filtered = bundleIdList.filter(id => {
        const p = this.d_productList.parameters[shop_index].parameters[id];
        return (
          p &&
          p.data &&
          p.data.data &&
          p.data.data['0'] &&
          p.data.data['0']['20'] &&
          p.data.data['0']['20'].val &&
          p.data.data['0']['20'].val.value === '1'
        );
      });

      if (filtered.length >= 3) {
        while (this.d_randomThreeBundle[shop_index].length < 3) {
          let rand_int_bundle = this.f_randomInt(1, filtered.length) - 1;
          let match_index = bundleIdList[rand_int_bundle]
          let rand_bund = {
            'client_id': this.d_productList.parameters[shop_index].parameters[match_index].data.client_id,
            'data': this.d_productList.parameters[shop_index].parameters[match_index],
          };
          let same_bundle = false;
          for (let i in this.d_randomThreeBundle[shop_index]) {
            if (this.d_randomThreeBundle[shop_index][i].client_id == rand_bund['client_id']) {
              same_bundle = true;
            }
          }
          if (!same_bundle) {
            this.d_randomThreeBundle[shop_index].push(rand_bund);
          }
        }
      }
    },
    'f_randomInt': function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  watch: {}
};

</script>

<style type="text/css">
.product-card {
  font-size: 14px;
  height: 100%;
  min-height: 300px;
  color: black;
  border-radius: 20px 20px 20px 20px;
  margin-bottom: 0px;
  border: none;
  box-shadow: 0px 0px 1px 1px #bcb1b1;
}  

.product-card:hover {
  font-size: 14px;
  height: 100%;
  min-height: 300px;
  color: black;
  border-radius: 20px 20px 20px 20px;
  margin-bottom: 0px;
  margin: -1px;
  border: none;
  box-shadow: -1px 1px 3px 3px #bcb1b1;
  cursor: pointer;
}    

.bundle-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.bundle-card-list {
  margin: 0px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap:16px;

  background: #f8fafc; /* very light blue */
  border: 1px solid #dbe3ef;
  padding: 22px 26px;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06); /* soft blue shadow */
  transition: all 0.25s ease;
  cursor: pointer;
}
.bundle-card-card {
  background: #f8fafc; /* very light blue */
  border: 1px solid #dbe3ef;
  padding: 22px 26px;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06); /* soft blue shadow */
  transition: all 0.25s ease;
  cursor: pointer;
}

.bundle-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.10); /* deeper blue shadow */
}
.bundle-card-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.10); /* deeper blue shadow */
}
.bundle-card-list:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.10); /* deeper blue shadow */
}

.bundle-left h3 {
  margin: 0;
  min-width: 0px;
  font-size: 18px;
  color: #0f172a; /* deep navy for strong contrast */
  font-weight: 600;
  line-height: 1.4;
}

.bundle-left .uploaded {
  margin: 6px 0 0;
  font-size: 14px;
  color: #64748b; /* steel-blue text */
}

.bundle-price {
  font-size: 12px;
  font-weight: 700;
  min-width: 150px;
  text-align: center;
  color: white;
  background: linear-gradient(to bottom right, #1FA2FF, #12D8FA);
  padding: 10px 18px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(3, 105, 161, 0.25);
}

.top-info-card {
  background: #f0f9ff !important;
  border: 1px solid #dbe3ef;
  padding: 18px 22px !important;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06);
  transition: all 0.25s ease;
  margin: 0 15px;
}

/*.top-info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.10);
}*/

/* İç düzen: bundle-left benzeri hizalama */
.top-info-card .info-left strong {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.4;
}

.top-info-card .info-icon {
  font-size: 18px;
  color: #64748b;
  margin-right: 6px;
}

.top-info-card strong {
  color: #0f172a;
  font-size: 15px;
}
.bundle-right{
  display: flex;
  gap:10px;
  flex-shrink: 0;
}
.bundle-right-dataset{
  font-size: 12px;
  font-weight: 700;
  min-width: 150px;
  color: white;
  background: linear-gradient(to bottom right, #433737, #c7c7c7);
  padding: 10px 18px;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(3, 105, 161, 0.25);
  text-align: center;
}
@media (max-width: 1200px){

  .bundle-right{
    flex-direction: column;
    align-items: flex-end;
    gap:6px;
  }
  .bundle-price{
    font-size:12px;
    padding:6px 12px;
  }

}


</style>

